import { useI18n } from 'vue-i18n'
import usePost from '@/core/composables/api/usePost'
import { ApiRequestStatus } from '@/core/models/api/api-request-status'
import { useSnackStore } from '@/stores/snack.store'
import type { StartLessonBody } from '../models/lesson'

export const useStartLesson = () => {
  const { t } = useI18n()
  const snackStore = useSnackStore()
  const { data, status, mutate } = usePost<{ id: string }, StartLessonBody>('lesson')

  const startLesson = async (body: StartLessonBody): Promise<string | null> => {
    const title = body.title?.trim()
    const payload: StartLessonBody = {
      lessonImpulseId: body.lessonImpulseId,
      ...(title ? { title } : {}),
      ...(body.teamIds?.length ? { teamIds: body.teamIds } : {}),
      ...(body.memberIds?.length ? { memberIds: body.memberIds } : {}),
    }

    await mutate(payload)

    if (status.value === ApiRequestStatus.Success && data.value?.id) {
      return data.value.id
    }

    snackStore.showError(t('lumia.lesson.snackbar.startError'))
    return null
  }

  return { startLesson, status }
}
